export default __webpack_public_path__ + "static/media/delete-media-icon.ec750066.svg";